import { Routes, UrlSegment, UrlMatchResult, UrlSegmentGroup } from '@angular/router';

const sellerPagePaths = [
  'vendre-vetement-occasion',
  'sell-second-hand-clothes',
  'second-hand-online-verkaufen',
  'vendita-seconda-mano-online-abbigliamento',
  'vender-ropa-lujo-segunda-mano'
];

const commissionPagePaths = [
  'notre-commission',
  'unsere-provision',
  'our-commission',
  'nuestra-comision',
  'nostra-commissione'
];

const sellerRatingPagePaths = [
  'seller-badges',
  'vendeur-badges',
  'verkaufer-abzeichen',
  'venditori-attestato',
  'vendedores-insignias'
];

const landingPagePaths = [...sellerPagePaths, ...commissionPagePaths, ...sellerRatingPagePaths];

export function landingPageUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (url.length > 0 && landingPagePaths.includes(url[0].path)) {
    return { consumed: url };
  }
  return null;
}

export function sellerPageUrlMatcher(url: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult {
  if (group.segments.length > 1 && sellerPagePaths.includes(group.segments[0].path)) {
    return { consumed: url };
  }
  return null;
}

export function commissionPageUrlMatcher(url: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult {
  if (group.segments.length > 1 && commissionPagePaths.includes(group.segments[0].path)) {
    return { consumed: url };
  }
  return null;
}

export function sellerRatingPageUrlMatcher(url: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult {
  if (group.segments.length > 1 && sellerRatingPagePaths.includes(group.segments[0].path)) {
    return { consumed: url };
  }
  return null;
}

export const landingRoutes: Routes = [
  {
    matcher: sellerPageUrlMatcher,
    loadChildren: () => import('./seller-page/seller-page.module').then(m => m.SellerPageModule),
    data: { pageAnalytics: { env_template: 'new_visitor_sell', list_products: [] } }
  },
  {
    matcher: commissionPageUrlMatcher,
    loadChildren: () => import('./commission-page/commission-page.module').then(m => m.CommissionPageModule),
    data: { pageAnalytics: { env_template: 'commission' } }
  },
  {
    matcher: sellerRatingPageUrlMatcher,
    loadChildren: () => import('./seller-rating-page/seller-rating-page.module').then(m => m.SellerRatingPageModule),
    data: { pageAnalytics: { env_template: 'seller-rating', pageUrl: '/seller-badges' } }
  }
];
